{
  "alert": "Upozornenie",
  "dismiss": "Zrušiť"
}